import api from './api'

const ENDPOINT = '/admin/documents'

export default {
  /**
   * Get all documents with pagination and filters
   * @param {Object} params - Query parameters (page, perPage, filters)
   */
  async getAll(params = {}) {
    const response = await api.get(ENDPOINT, { params })
    return response.data
  },

  /**
   * Get single document by ID
   * @param {number} id - Document ID
   * @param {Object} params - Query parameters
   */
  async getById(id, params = {}) {
    const response = await api.get(`${ENDPOINT}/${id}`, { params })
    return response.data
  },

  /**
   * Create new document (FormData)
   * @param {FormData} formData - Document form data with files
   */
  async create(formData) {
    // Don't set Content-Type manually - axios will set it with proper boundary for FormData
    const response = await api.post(ENDPOINT, formData)
    return response.data
  },

  /**
   * Update document (FormData with POST + _method=PUT)
   * @param {number} id - Document ID
   * @param {FormData} formData - Document form data with files
   */
  async update(id, formData) {
    // Laravel requires POST with _method=PUT for file uploads
    // Don't set Content-Type manually - axios will set it with proper boundary for FormData
    const response = await api.post(`${ENDPOINT}/${id}`, formData)
    return response.data
  },

  /**
   * Delete document
   * @param {number} id - Document ID
   */
  async delete(id) {
    const response = await api.delete(`${ENDPOINT}/${id}`)
    return response.data
  },
}
